import { useMemo } from 'react';
import classNames from 'classnames';

import { Button } from '../button/button.component';
import Svg from '../svg/svg.component';
import { Title } from '../title/title.component';
import { getComponentFromProps, getPropsFromModel } from '../../utils/use-child-components';

import { QuotesProps, QuotesType } from './quotes.config';

const Quotes = ({
  additionalClasses,
  appliedCssClassNames,
  button,
  cqPath,
  image_quotes_carousel: imageQuotesCarousel,
  quotes_carousel: quotesCarousel,
  title,
  type,
  video_quotes_carousel: videoQuotesCarousel,
}: QuotesProps) => {
  const quotesCarouselProps = getPropsFromModel(quotesCarousel, cqPath, 'quotes_carousel');
  const QuotesCarousel = getComponentFromProps(quotesCarouselProps);

  const imageQuotesCarouselProps = getPropsFromModel(imageQuotesCarousel, cqPath, 'image_quotes_carousel');
  const ImageQuotesCarousel = getComponentFromProps(imageQuotesCarouselProps);

  const videoQuotesCarouselProps = getPropsFromModel(videoQuotesCarousel, cqPath, 'video_quotes_carousel');
  const VideoQuotesCarousel = getComponentFromProps(videoQuotesCarouselProps);

  const isGradientBg = useMemo(
    () => appliedCssClassNames?.includes('snowflake-quotes-gradient-bg'),
    [appliedCssClassNames]
  );

  return (
    <div data-testid="snowflake-quotes-wrapper" className={classNames('snowflake-quotes-wrapper', additionalClasses)}>
      {type === QuotesType.QUOTES ? (
        <Svg name="arrow" data-testid="snowflake-quotes-brand-img" className="snowflake-quotes-brand-img" />
      ) : (
        <Svg
          name="quotes-arrow"
          className={classNames('snowflake-quotes-arrow', { 'snowflake-quotes-arrow-gradient-bg': isGradientBg })}
        />
      )}
      {title && (
        <div
          data-testid="snowflake-quotes-title"
          className={classNames('snowflake-quotes-title center', {
            'white-background': !isGradientBg,
            'blue-background': isGradientBg,
          })}
        >
          <Title {...title} />
        </div>
      )}
      {QuotesCarousel && (
        <div data-testid="snowflake-quotes-carousel">
          <QuotesCarousel
            {...quotesCarouselProps}
            appliedCssClassNames={appliedCssClassNames}
            isArrowWhite={isGradientBg}
            isBulletWhite={isGradientBg}
          />
        </div>
      )}
      {ImageQuotesCarousel && (
        <div className="snowflake-quotes-carousel-with-image" data-testid="snowflake-quotes-carousel-with-image">
          <ImageQuotesCarousel
            {...imageQuotesCarouselProps}
            appliedCssClassNames={appliedCssClassNames}
            isArrowWhite={isGradientBg}
            isBulletWhite={isGradientBg}
          />
        </div>
      )}
      {VideoQuotesCarousel && (
        <div className="snowflake-quotes-carousel-with-video" data-testid="snowflake-quotes-carousel-with-video">
          <VideoQuotesCarousel
            {...videoQuotesCarouselProps}
            appliedCssClassNames={appliedCssClassNames}
            isArrowWhite={isGradientBg}
            isBulletWhite={isGradientBg}
          />
        </div>
      )}
      {button && (
        <div
          className={classNames('snowflake-quotes-button snowflake-button-primary snowflake-button-regular', {
            'snowflake-button-blue': !isGradientBg,
            'snowflake-button-white': isGradientBg,
          })}
          data-testid="snowflake-quotes-button"
        >
          <Button {...button} />
        </div>
      )}
    </div>
  );
};

export default Quotes;
